module.exports = __webpack_public_path__ + "img/bayer-logo.c35cf856.png";